import { localize } from '@/utils/i18n.js'

export const text = {
    lead: localize({
        ru:
            'Главная ценность компании — это, конечно, люди, настоящие профессионалы своего дела. Мы уверены, что залог успеха — это преданность своему делу, профессии. Каждый из нас искренне любит свое дело, работает с полной отдачей и зачастую превосходит сам себя.',
        en:
            'The core value of the Company is its people, craft professionals. We are absolutely sure the key success factor is devotion to one`s duty and profession. We are all devoted to our business and do our part to the best of the ability.'
    }),
    caption: localize({
        ru: 'Наша цель — создавать лучшее будущее!',
        en: 'We work to build a better future.'
    }),
    main: localize({
        ru: 'Распадская в лицах – история успеха',
        en: 'Raspadskaya is represented by its people – success stories'
    }),
    author: {
        name: localize({
            ru: 'Евгений Бондарев',
            en: 'Евгений Бондарев'
        }),
        info: localize({
            ru:
                'Здорово быть частью такой сильной и амбициозной компании. Для меня Распадская — это в первую очередь ее люди. Учиться у лучших каждый день — огромная привилегия и Распадская дает такую возможность каждому.',
            en:
                'Здорово быть частью такой сильной и амбициозной компании. Для меня Распадская — это в первую очередь ее люди. Учиться у лучших каждый день — огромная привилегия и Распадская дает такую возможность каждому.'
        }),
        photo: localize({
            ru: '',
            en: ''
        })
    }
}

export const textDetail = {
    linkText: localize({
        ru: 'Вернуться к списку',
        en: 'Back to list'
    }),
    work: localize({
        ru: 'Работает с',
        en: 'Working since'
    }),
    story: localize({
        ru: 'История успеха',
        en: 'History of success'
    })
}
